import { render, staticRenderFns } from "./perfectlooper-control-bar.vue?vue&type=template&id=20cd3d84&"
import script from "./perfectlooper-control-bar.vue?vue&type=script&lang=js&"
export * from "./perfectlooper-control-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports